import { AccountModel, AccountsFactory, Button, DialogHandler, EStorageType, FullBar, GenericWrapper, LoadingContainer, SideMenu, SubNav, UserModel, UsersFactory, amIImpersonating, amILoggedInService, fetchRoute, loginService, popImpersonificationTree, setStorage, uiKitConfig } from "cakemail-ui-components-v2"
import { Key, useEffect, useState } from "react"
import LocizeInitializer from "../../components/locize"
import { errorHandler } from "../../utils/api"
import { ERoutes } from "../../utils/url"
import { SignInUp } from "../signInUp"
import AssetManager from "../assetManager"
import SystemEmails from "../systemEmails"
import "./styles.css"
import { EmailAPI } from "../emailAPI"
import moment from "moment"
import { Dashboard } from "../dashboard"
import { Onboarding } from "../onboarding"
import { TOnboardingCompleted } from "../onboarding/types"
import { Stack } from "@mui/material"
import { HashRouter, Route, Routes } from "react-router-dom"
import { AppMenu } from "../../components/AppMenu"

uiKitConfig.GATEWAY_PROXY = window.location.origin + "/api"
//@ts-ignore
uiKitConfig.ERROR_HANDLER = errorHandler

export function App() {
	const [authenticated, setAuthenticated] = useState<boolean | undefined>()
	const [account, setAccount] = useState<AccountModel>()
	const [user, setUser] = useState<UserModel>()

	const [logInspect, setLogInspect] = useState<number>()

	useEffect(init, [])

	function init() {
		//TODO Use formatNumber(number, userLang) to output number display

		//Email API data account
		//setStorage({ key: "impersonificationTree", data: ["131010", "133315", "1625181", "1627783"], type: EStorageType.session })//"1625181"
		//User
		//setStorage({ key: "impersonificationTree", data: ["1475072"], type: EStorageType.session })
		//Reseller
		//setStorage({ key: "impersonificationTree", data: ["1500224"], type: EStorageType.session })

		validateSession().then((a) => {
			if (a.data.loggedIn) {
				const whoAmi = []
				//get proper account, has to be swapped depending on which account you use. Self will not work.
				whoAmi.push(AccountsFactory.get({ id: "self" }))

				whoAmi.push(UsersFactory.get({ id: "self" }))

				Promise.allSettled(whoAmi).then((results: PromiseSettledResult<AccountModel | UserModel>[]) => {
					const obj: any = {}
					results.forEach((instance) => {
						if (instance.status === "fulfilled") {
							if (instance.value instanceof AccountModel) {
								obj.account = instance.value
							} else {
								obj.user = instance.value
							}
						}
					})

					if (!obj.account || !obj.user) {
						throw new Error("Not logged in")
					} else {
						//identify("CakemailAdminDev")
						setAccount(obj.account)
						setUser(obj.user)

						moment.locale(obj.user.language.replace("_", "-"))
					}
				})
			}
			throw new Error("Not logged in")
		}).catch(({ msg, response }) => {
			DialogHandler.show({
				title: "Failed to get account",
				type: "error"
			})
		})

	}

	async function validateSession() {

		return amILoggedInService().then((res) => {
			setAuthenticated(res.data.loggedIn)
			return res
		}).catch(() => {
			setAuthenticated(false)
		})
	}

	function submitForm(email: string, password: string) {
		loginService({ email, password }).then((res) => {
			if (res.loggedIn)
				init()
		}).catch((error) => {
			DialogHandler.show({
				title: "Invalid username/password",
				type: "error"
			})
		})
	}

	function handleLogout() {
		if (amIImpersonating()) {
			popImpersonificationTree()
		} else {
			account?.logOut().then(() => {
				window.sessionStorage.clear()
				window.location.reload()
			})
		}
	}


	async function onOnboardingCompleted(onboardingData: TOnboardingCompleted) {
		console.log(onboardingData)
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve()
			}, 3000)
		})
	}

	const isReady = account && user && authenticated

	return <HashRouter>
		<GenericWrapper brandHost="https://us-central1-brand-prod.cloudfunctions.net" brandId="app.cakemail.com" setPageHead setPostHog account={account} user={user} LocizeInitializer={LocizeInitializer}>
			<LoadingContainer loading={!isReady && authenticated === true}>
				{isReady === true &&
					<Stack direction="row" className="appContent">
						<AppMenu onLogout={handleLogout} />
						<Stack direction="column" className="appContent" flex={1} overflow="auto" height="100vh">
							<FullBar
								stackProps={{
									//@ts-ignore
									style: {
										flex: 0,
										padding: "1rem",
										borderBottom: "1px solid grey"
									}
								}}
								right={<Button key="1" onClick={handleLogout}>Log out</Button>}
								left={
									<SubNav
										key="2"
										onClick={(event, item) => {
											//@ts-ignore
											window.location = "#" + item.name
										}}
										initialSelected={window.location.hash.substring(1)}
										items={[
											{ name: fetchRoute({ route: ERoutes.dashboard }), text: "Dashboard" },
											{ name: fetchRoute({ route: ERoutes.assets }), text: "Templates" },
											{ name: fetchRoute({ route: ERoutes.systemEmail }), text: "System emails" },
											{ name: fetchRoute({ route: ERoutes.emailAPI }), text: "Email API" },
											{ name: fetchRoute({ route: ERoutes.onboarding }), text: "Onboarding" }
										]}
									/>
								} />

							<Routes>
								<Route path={fetchRoute({ route: ERoutes.assets }) + "/*"} element={<AssetManager />} />
								<Route path={fetchRoute({ route: ERoutes.systemEmail }) + "/*"} element={<SystemEmails />} />
								<Route path={fetchRoute({ route: ERoutes.emailAPI }) + "/*"} element={<EmailAPI />} />
								<Route path={fetchRoute({ route: ERoutes.dashboard }) + "/*"} element={<Dashboard />} />
								<Route path={fetchRoute({ route: ERoutes.onboarding }) + "/*"} element={<Onboarding setUser={setUser} onOnboardingCompleted={onOnboardingCompleted} />} />
							</Routes>



						</Stack>
					</Stack>
				}
				{authenticated === false &&
					<SignInUp submitForm={submitForm} />
				}
			</LoadingContainer>

		</GenericWrapper>
	</HashRouter >


}
